import { DatePipe, TitleCasePipe } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from '@core/core.module';
import { SharedComponentsSysTextService } from '@core/services/shared-components-sys-text.service';
import { AccountModule } from '@modules/account/account.module';
import { DialogsModule } from '@modules/dialogs/dialogs.module';
import { LayoutModule } from '@modules/layout/layout.module';
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CaseCommunicationModule } from '@modules/case-communication/case-communication.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CookieService } from 'ngx-cookie-service';
import { ApplicationInsightsService } from '@core/services';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { appInsightsInterceptor } from '@core/interceptors/app-insights.interceptor';
import { NgxSonnerToaster } from 'ngx-sonner';

export function initApp1(sharedSysTextService: SharedComponentsSysTextService): () => Promise<any> {
  return (): Promise<any> => {
    return sharedSysTextService.init();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, CoreModule, SharedModule, AccountModule, LayoutModule, DialogsModule, CaseCommunicationModule, DragDropModule, NgxSonnerToaster],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill', subscriptSizing: 'dynamic' } },
    DatePipe,
    TitleCasePipe,
    SharedComponentsSysTextService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp1,
      multi: true,
      deps: [SharedComponentsSysTextService],
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        ...new MatDialogConfig(),
        autoFocus: false,
        disableClose: true,
        closeOnNavigation: true,
        maxWidth: '100%', // the window without its scrollbar (100vw includes it, so full-width dialogs went under it)
        maxHeight: '100vh'
        } as MatDialogConfig,
    },
    [CookieService],
    ApplicationInsightsService,
    provideHttpClient(withXhr(), withInterceptors([appInsightsInterceptor]))
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
